import { render, staticRenderFns } from "./AnswerSheet.vue?vue&type=template&id=4cd28d58&scoped=true"
import script from "./AnswerSheet.vue?vue&type=script&lang=js"
export * from "./AnswerSheet.vue?vue&type=script&lang=js"
import style0 from "./AnswerSheet.vue?vue&type=style&index=0&id=4cd28d58&prod&lang=scss&scoped=true"
import style1 from "./AnswerSheet.vue?vue&type=style&index=1&id=4cd28d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd28d58",
  null
  
)

export default component.exports